export enum SectionId {
  Quality = 'quality',
  Hygiene = 'hygiene',
  Safety = 'safety',
  Energy = 'energy',
  Montage = 'montage',
  Calculator = 'calculator',
}
